import contracts from "./contracts";
import requests from './requests';
import tasks from "./tasks";
import inWork from "./in-work";
import dialogs from "./dialogs";
import receptionSchedule from "./reception-schedule";

const qalaQyzmet = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    getters: {
    },
    modules: {
        contracts,
        requests,
        tasks,
        inWork,
        dialogs,
        receptionSchedule
    }
}

export default qalaQyzmet;